import { useState } from 'react';
import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import EffectMetrics from './components/EffectMetrics';
import WhatIsSoftSkills from './components/WhatIsSoftSkills';
import WhyCompaniesLoseMoney from './components/WhyCompaniesLoseMoney';
import WhenNeeded from './components/WhenNeeded';
import KeySoftSkills from './components/KeySoftSkills';
import SoftSkillsByRole from './components/SoftSkillsByRole';
import HowTrainingGoes from './components/HowTrainingGoes';
import WhyTrainingsFail from './components/WhyTrainingsFail';
import CompanyResults from './components/CompanyResults';
import TrainingFormats from './components/TrainingFormats';
import WhyWorkWithMe from './components/WhyWorkWithMe';
import UsefulMaterials from './components/UsefulMaterials';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import EmotionalCTA from './components/EmotionalCTA';
import ReadNextSection from './components/ReadNextSection';
import SEOLinks from './components/SEOLinks';
import Footer from '@/components/feature/Footer';

function PageMeta() {
  return (
    <>
      <SeoTitle title="Развитие Soft Skills | Business Training" />
      <meta name="description" content="Развитие Soft Skills: тренинги по коммуникации, эмоциональному интеллекту, тайм-менеджменту и работе в команде." />
      <meta name="keywords" content="корпоративные тренинги, обучение сотрудников, тренинги по продажам, тренинг по переговорам, тренинг по лидерству, тимбилдинг Минск, бизнес-игры Беларусь, тренинг для отдела продаж, soft skills, Минск, Беларусь" />
      <link rel="canonical" href="https://business-training.by/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills" />
      <meta property="og:title" content="Развитие Soft Skills | Business Training" />
      <meta property="og:description" content="Развитие Soft Skills: тренинги по коммуникации, эмоциональному интеллекту, тайм-менеджменту и работе в команде." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://business-training.by/enciklopediya-korporativnogo-obucheniya/razvitie-soft-skills" />
      <meta property="og:locale" content="ru_RU" />
      <meta property="og:image" content="https://readdy.ai/api/search-image?query=Professional%20corporate%20soft%20skills%20training%20with%20diverse%20team%20collaborating%20in%20bright%20modern%20office%2C%20warm%20natural%20daylight%2C%20energetic%20engaged%20atmosphere%2C%20soft%20cream%20neutral%20tones%2C%20clean%20contemporary%20aesthetic%2C%20abstract%20professional%20setting%2C%20no%20text%20no%20logos&width=1200&height=630&seq=soft-skills-og-2026&orientation=landscape" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Развитие Soft Skills | Business Training" />
      <meta name="twitter:description" content="Развитие Soft Skills: тренинги по коммуникации, эмоциональному интеллекту, тайм-менеджменту и работе в команде." />
      <meta name="twitter:image" content="https://readdy.ai/api/search-image?query=Professional%20corporate%20soft%20skills%20training%20with%20diverse%20team%20collaborating%20in%20bright%20modern%20office%2C%20warm%20natural%20daylight%2C%20energetic%20engaged%20atmosphere%2C%20soft%20cream%20neutral%20tones%2C%20clean%20contemporary%20aesthetic%2C%20abstract%20professional%20setting%2C%20no%20text%20no%20logos&width=1200&height=630&seq=soft-skills-og-2026&orientation=landscape" />
      <meta name="last-modified" content="2026-07-16" />
      <meta name="geo.region" content="BY" />
      <meta name="geo.placename" content="Минск" />
      <meta name="geo.position" content="53.9006;27.5590" />
    </>
  );
}

const softSkillsNavLinks = [
  { label: 'Навыки', target: 'skills' },
  { label: 'Программа', target: 'program' },
  { label: 'Результаты', target: 'results' },
  { label: 'FAQ', target: 'faq' },
];

export default function SoftSkillsPage() {


  return (
    <>
      
      <SeoTitle title="Развитие Soft Skills | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={softSkillsNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />
        <EffectMetrics />
        <WhatIsSoftSkills />
        <WhyCompaniesLoseMoney />
        <WhenNeeded />
        <div id="skills">
          <KeySoftSkills />
        </div>
        <SoftSkillsByRole />
        <div id="program">
          <HowTrainingGoes />
        </div>
        <WhyTrainingsFail />
        <div id="results">
          <CompanyResults />
        </div>
        <TrainingFormats />
        <WhyWorkWithMe />
        <UsefulMaterials />
        <FAQSection />
        <CTASection />
        <EmotionalCTA />
        <ReadNextSection />
        <SEOLinks />
        <Footer />
      </div>
    </>
  );
}